var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face_2",
    d: "M9 14.25C8.65 14.25 8.35417 14.1292 8.1125 13.8875C7.87083 13.6458 7.75 13.35 7.75 13C7.75 12.65 7.87083 12.3542 8.1125 12.1125C8.35417 11.8708 8.65 11.75 9 11.75C9.35 11.75 9.64583 11.8708 9.8875 12.1125C10.1292 12.3542 10.25 12.65 10.25 13C10.25 13.35 10.1292 13.6458 9.8875 13.8875C9.64583 14.1292 9.35 14.25 9 14.25ZM15 14.25C14.65 14.25 14.3542 14.1292 14.1125 13.8875C13.8708 13.6458 13.75 13.35 13.75 13C13.75 12.65 13.8708 12.3542 14.1125 12.1125C14.3542 11.8708 14.65 11.75 15 11.75C15.35 11.75 15.6458 11.8708 15.8875 12.1125C16.1292 12.3542 16.25 12.65 16.25 13C16.25 13.35 16.1292 13.6458 15.8875 13.8875C15.6458 14.1292 15.35 14.25 15 14.25ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.6 19.975 11.2125 19.925 10.8375C19.875 10.4625 19.7833 10.1 19.65 9.75C19.3 9.83333 18.95 9.89583 18.6 9.9375C18.25 9.97917 17.8833 10 17.5 10C15.9833 10 14.55 9.675 13.2 9.025C11.85 8.375 10.7 7.46667 9.75 6.3C9.21667 7.6 8.45417 8.72917 7.4625 9.6875C6.47083 10.6458 5.31667 11.3667 4 11.85V12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9982 2.5C13.3122 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9982C21.5 13.3122 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM10.1787 4.22125C10.9364 5.61858 11.9874 6.68108 13.3318 7.40875C14.6759 8.13625 16.0653 8.5 17.5 8.5C17.7718 8.5 18.0369 8.48592 18.2952 8.45775C18.5536 8.42958 18.8154 8.38917 19.0807 8.3365C18.4127 7.00967 17.4452 5.95517 16.178 5.173C14.9107 4.391 13.518 4 12 4C11.6642 4 11.351 4.01892 11.0605 4.05675C10.7702 4.09458 10.4762 4.14942 10.1787 4.22125ZM4.28075 10.0905C5.22058 9.62 6.11292 8.9325 6.95775 8.028C7.80258 7.1235 8.34808 6.03917 8.59425 4.775C7.50058 5.27117 6.57625 5.98433 5.82125 6.9145C5.06608 7.84467 4.55258 8.90333 4.28075 10.0905Z",
    fill: "url(#paint0_linear_0_123)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_123",
    x1: 2.38456,
    y1: 3.32753,
    x2: 24.7851,
    y2: 10.9068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.251b658794c57e201e23e125fe29337b.svg";
export { ForwardRef as ReactComponent };